import { useHistory } from "react-router-dom";

const Nav = ({ on, fname }) => {
  const history = useHistory();

  const handleSignout = () => {
    history.push("/");
  };

  return (
    <>
      <div
        className="logo"
        style={{ margin: "0 auto 25px auto", display: "block" }}
      >
        <img
          src="https://vto.qnmcdn.com/assets/img/benefit-for-children-logo.png"
          alt="BFC"
          style={{ width: "35%", display: "block", margin: "0px auto" }}
        />
      </div>

      {fname && (
        <div className="steps" style={{ paddingBottom: "25px" }}>
          <h4>{`Welcome, ${fname}`}</h4>

          <button
            type="button"
            className="btn-alt"
            onClick={() => handleSignout()}
          >
            Sign Out
          </button>
        </div>
      )}

      <div className="blocktext" style={{ marginTop: "20px" }}>
        Questions? Please contact Samantha Murray at (210) 345-5279 or email{" "}
        <a href={`mailto:valerobfc@valero.com`}>valerobfc@valero.com</a>.
      </div>
    </>
  );
};

export default Nav;
